// Utility function to construct image URLs
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
// REACT_APP_UPLOADS_URL should be set in .env.production (e.g. /api/uploads).
// Local dev fallback: strip trailing /api from API_BASE and append /uploads.
const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL
  || `${API_BASE.replace(/\/api$/, '')}/uploads`;

export const getImageUrl = (image, folder = 'general') => {
  if (!image) return null;

  // Handle different image object structures
  const filename = image.filename || image;
  const imageFolder = image.folder || folder;

  return `${UPLOADS_BASE}/${imageFolder}/${filename}`;
};

export const getProjectImageUrl = (project) => {
  // Try to get image from different possible sources
  if (project.filename) {
    return getImageUrl(project.filename, project.folder || 'projects');
  }

  if (project.images && project.images.length > 0) {
    return getImageUrl(project.images[0].filename, project.images[0].folder || 'projects');
  }

  return null;
};
